/**
 * main.tsx
 * 
 * This is the main entry point of the React application.
 * It serves as the bootstrap file that:
 * 
 * - Imports the root App component
 * - Imports global CSS styles
 * - Renders the App component into the DOM
 * - Sets up React 18's createRoot API for concurrent features
 * 
 * This file is responsible for initializing the React application
 * and mounting it to the HTML element with id 'root'.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 